var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PRIORITY",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45.92,29.42c3.63,4.39,5.62,9.96,5.62,15.66,0,13.58-11.04,24.62-24.62,24.62S2.3,58.65,2.3,45.08s11.04-24.62,24.62-24.62c5.67,0,11.2,1.97,15.58,5.56l1.46-1.78c-4.79-3.92-10.84-6.08-17.04-6.08C12.08,18.16,0,30.23,0,45.08s12.08,26.92,26.92,26.92,26.92-12.08,26.92-26.92c0-6.24-2.18-12.32-6.15-17.12l-1.77,1.46Zm-6.97-.04c-3.48-2.67-7.64-4.08-12.03-4.08-10.91,0-19.78,8.87-19.78,19.78s8.87,19.78,19.78,19.78,19.78-8.87,19.78-19.78c0-4.38-1.4-8.53-4.06-12.01l-1.83,1.4c2.35,3.07,3.58,6.74,3.58,10.61,0,9.64-7.84,17.48-17.48,17.48s-17.48-7.84-17.48-17.48,7.84-17.48,17.48-17.48c3.88,0,7.56,1.25,10.63,3.6l1.4-1.82Zm-12.03,5.35c2.05,0,4.04.6,5.74,1.74l1.28-1.91c-2.08-1.39-4.51-2.12-7.02-2.12-6.97,0-12.65,5.67-12.65,12.65s5.67,12.65,12.65,12.65,12.65-5.67,12.65-12.65c0-2.54-.75-4.98-2.16-7.07l-1.91,1.29c1.16,1.71,1.77,3.71,1.77,5.79,0,5.71-4.64,10.35-10.35,10.35s-10.35-4.64-10.35-10.35,4.64-10.35,10.35-10.35ZM63.46,8.54V.02l-11.25,11.12v6.93l-22.65,22.65,1.63,1.63,22.67-22.67h6.97l11.28-11.15h-8.64Zm-3.58,8.85h-5.37v-5.28l6.65-6.58v5.31h5.34l-6.63,6.55Z",
    fill: "#1d1d1b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/goals.e6c964406653c92b9be0f2516813b323.svg";
export { ForwardRef as ReactComponent };